import React from "react";
import LineGraph from "../../../modules/LineGraph";
import { formatToMB, formatBitsPerSecond } from "../../../utils/StringUtil";

interface DiagnosticsMetricsAdvancedChartProps {
  deviceId: string;
  metric_data: MetricSample[];
  dynamic_metric: string;
  loaded: boolean;
}

interface MetricSample {
  time: number;
  [key: string]: number;
}

const DiagnosticsMetricsAdvancedChart: React.FC<DiagnosticsMetricsAdvancedChartProps> = ({
  deviceId = "",
  metric_data = [],
  dynamic_metric = "",
  loaded = false,
}) => {
  // use bps for firewall.transfer.persec as it is a network speed
  const getYAxisFormatter = () => {
    if (dynamic_metric === "firewall.transfer.persec") {
      return formatBitsPerSecond;
    } else {
      return formatToMB;
    }
  };

  return (
    <div className="main-content-sub-element line-chart-container">
      <div className="row">
        <div className="col-md-12">
          {deviceId} — {dynamic_metric}
          <LineGraph
            data={metric_data}
            container={deviceId}
            yAxisFormatter={getYAxisFormatter()}
            xAxisFormatter="formatUnixTimestamp"
            dataLoaded={loaded}
          />
        </div>
      </div>
    </div>
  );
};

export default DiagnosticsMetricsAdvancedChart;
